import React, { useEffect, useRef } from 'react';

/**
 * Educational Tooltip - Shows info on hover using Bootstrap tooltips
 * @param {string} title - Tooltip title/content
 * @param {string} placement - top|bottom|left|right (default: top)
 * @param {string} icon - FA icon (default: fa-info-circle)
 * @param {string} className - Additional classes for icon
 */
const EducationalTooltip = ({ title, placement = 'top', icon = 'fa-info-circle', className = 'text-info' }) => {
  const iconRef = useRef(null);

  useEffect(() => {
    if (iconRef.current && window.bootstrap) {
      const tooltip = new window.bootstrap.Tooltip(iconRef.current, {
        title,
        placement,
        trigger: 'hover',
        html: true
      });
      return () => tooltip.dispose();
    }
  }, [title, placement]);

  return <i ref={iconRef} className={`fas ${icon} ${className} ms-1 cursor-pointer`} data-bs-toggle="tooltip" title={title} />;
};

export default EducationalTooltip;
